import { useLocation } from "react-router-dom";
import {
  createColumn,
  createDeactivateAction,
  formatDateTime,
} from "../../utils/helpers";
import useDownload from "../common/useDownload";
import { useEffect } from "react";
import { Button, message } from "antd";
import { API_STICKERS_DOWNLOAD } from "../../utils/apis";
import { FormActions } from "../../components/common/FormActions";
// import { URL_REGISTER_VIEW_STICKER_BOOKING } from "../../utils/urls";

export const useViewStickers = () => {
  const { state } = useLocation();
  const item = state?.item;

  const {
    downloadFile,
    success: downloadSuccess,
    error: downloadError,
    downloading: isDownloading,
  } = useDownload();

  useEffect(() => {
    if (downloadSuccess) {
      message.success("File downloaded successfully");
    }

    if (Object?.keys(downloadError)?.length > 0) {
      message.error(downloadError?.message || "Failed to download file");
    }
  }, [downloadSuccess, downloadError]);

  const tableColumns = () => [
    createColumn("sticker_number", false),
    createColumn("created_by", false),
    createColumn("created_at", false),
    createColumn("receipt", false),
    { id: "actions", header: "Actions" },
  ];

  const handleDownloadReceipt = (sticker) => {
    const fileName = `Receipt_${sticker.sticker_number}_${Date.now()}.pdf`;
    downloadFile({
      api: `${API_STICKERS_DOWNLOAD}${sticker.id}/receipt/`,
      filename: fileName,
    });
  };

  const tableData = () => {
    if (!item?.stickers) return [];

    return item.stickers.map((sticker) => ({
      sticker_number: sticker?.sticker_number,
      created_by:
        `${sticker?.created_by?.first_name} ${sticker?.created_by?.last_name}` ||
        sticker?.created_by?.first_name ||
        "Unknown",
      created_at: formatDateTime(sticker?.created_at),
      receipt: (
        <Button
          onClick={() => handleDownloadReceipt(sticker)}
          className="font12 noShadow"
          type="primary"
          loading={isDownloading}
          disabled={isDownloading}
        >
          {isDownloading ? "Downloading..." : "Download Sticker"}
        </Button>
      ),
      // Add actions column
      actions: (
        <FormActions
          actions={[
            // createViewAction(URL_REGISTER_VIEW_STICKER_BOOKING, sticker.id),
            createDeactivateAction(
              `${API_STICKERS_DOWNLOAD}${sticker.id}/deactivate/`,
              `sticker ${sticker.sticker_number}`,
              {},
              {
                showReasonField: true,
                method: "PATCH",
              },
            ),
          ]}
        />
      ),
    }));
  };

  return { tableData, tableColumns };
};
